class ListDealersController {
  constructor($stateParams, entityService, loadingService) {
    "ngInject";

    this._$stateParams = $stateParams;
    this._entityService = entityService;
    this.loadingService = loadingService;

    this.parent = {};
    this.dealers = [];

    this.listDealers($stateParams.entityId);
  }

  listDealers(companyId) {
    let listDealersCtrl = this;

    listDealersCtrl.loadingService.showLoading('dealerList', 'Loading Entities ...');

    this._entityService.listEntities(2, companyId)
      .then(response => {
        listDealersCtrl.parent = {
          id: response.data.parentId,
          name: response.data.parentName
        };

        listDealersCtrl.dealers  = response.data.data;
      })
      .finally(() => {
        listDealersCtrl.loadingService.hideLoading('dealerList');
      });
  }
}

export default ListDealersController;



// WEBPACK FOOTER //
// ./client/app/components/admin/entity/list/listDealers/listDealers.controller.js